import type { FC, ReactNode } from 'react';
import { useLayoutEffect, useMemo } from 'react';

import { Title } from 'components/UI/Paper';
import StyledList from 'components/UI/StyledList';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import { title } from './constants';
import { setImgScaling } from './helpers/setImgScaling';

type IListItem =
    | ReactNode
    | {
          content: ReactNode;
          mark?: ReactNode;
      };

interface Props {
    /** Шаги для выполнения (desktop) */
    listDesktop: IListItem[];
    /** Шаги для выполнения (mobile) */
    listMobile: IListItem[];
}

const Template: FC<Props> = ({ listDesktop, listMobile }) => {
    const { isDesktop } = useDeviceWidth();
    const list = isDesktop ? listDesktop : listMobile;

    const listItems = useMemo(() => {
        return list.map((listItem, index) => {
            if (listItem && typeof listItem === 'object' && 'content' in listItem) {
                return { content: listItem.content, marker: listItem.mark };
            }

            return { content: listItem, marker: index + 1 };
        });
    }, [list]);

    useLayoutEffect(() => {
        setImgScaling(document.getElementById('instruction-list'));
    }, []);

    return (
        <>
            {isDesktop ? <Title>{title}</Title> : null}
            <StyledList listItems={listItems} id='instruction-list' />
        </>
    );
};

export default Template;
